

























































































































































import { namespace } from 'vuex-class'
import { Vue, Component, Watch } from 'vue-property-decorator'
import CustomMultiselect from '@/UI/Shared/CustomMultiselect.vue'
import { VueChosenOptions } from '@/UI/Shared/VueChosenOptions'
import RadioCheckGroup from '@/UI/Shared/RadioCheckGroup.vue'
import { VueInputCheckRadio } from '@/UI/Shared/VueInputCheckRadio'
import { StatementsData } from '@/Infrastructure/Store/Auction/StatementsData'
import ActivitiesSelector from '@/UI/Auction/Statements/ActivitiesSelector.vue'

const auctionStore = namespace('auction')
@Component({
  components: {
    CustomMultiselect,
    RadioCheckGroup,
    ActivitiesSelector
  }
})

export default class StatementsForm extends Vue {
  get rexistroOptions (): VueChosenOptions[] {
    return [
      { id: '1', label: 'Opción 1' },
      { id: '2', label: 'Opción 2' }
    ]
  }

  get checkBoxes (): VueInputCheckRadio[] {
    const radiosList = [
      {
        id: 'option3A',
        label: this.$t('subasta.statements.dec10_4_1').toString(),
        value: '1',
        name: 'option3A',
        checked: false
      },
      {
        id: 'option3B',
        label: this.$t('subasta.statements.dec10_4_2').toString(),
        value: '2',
        name: 'option3B',
        checked: false
      }
    ]
    return radiosList
  }

  @auctionStore.Getter
  public statementData!: StatementsData

  @auctionStore.Action
  public setStatementsData!: (StatementsData: StatementsData) => void

  get isValid (): boolean {
    if (!this.statementData.confirm) {
      return false
    }
    if (this.statementData.discapacidade && this.statementData.numDiscapacidade === '') {
      return false
    }
    if (this.statementData.temporais && this.statementData.numTemporais === '') {
      return false
    }
    if (this.statementData.mulleres && this.statementData.numMulleres === '') {
      return false
    }
    if (this.statementData.rexistroLicitadorXeral && this.statementData.licitadorXeral === '') {
      return false
    }
    if (this.statementData.rexistroLicitadorOficial && this.statementData.licitadorOficial === '') {
      return false
    }

    return true
  }

  @Watch('isValid')
  onIsValidChanged (newValue: boolean): void {
    if (newValue) {
      this.setStatementsData(this.statementData)
    }
    this.$emit('formValid', newValue)
  }

  @Watch('statementData.rexistroLicitadorXeral')
  onLicXeralChanged (newValue: boolean): void {
    if (!newValue) {
      this.statementData.licitadorXeral = ''
    }
  }

  @Watch('statementData.rexistroLicitadorOficial')
  onLicOficialChanged (newValue: boolean): void {
    if (!newValue) {
      this.statementData.licitadorOficial = ''
    }
  }

  @Watch('statementData.discapacidade')
  onDiscapacidadeChanged (newValue: boolean): void {
    if (!newValue) {
      this.statementData.numDiscapacidade = ''
    }
  }

  @Watch('statementData.temporais')
  onTemporaisChanged (newValue: boolean): void {
    if (!newValue) {
      this.statementData.numTemporais = ''
    }
  }

  @Watch('statementData.mulleres')
  onMulleresChanged (newValue: boolean): void {
    if (!newValue) {
      this.statementData.numMulleres = ''
    }
  }

  public onConfirm (read: boolean): void {
    this.statementData.confirm = read
  }

  public mounted (): void {
    this.checkBoxes.forEach(check => {
      if (this.statementData.option4Selected.includes(check.value.toString())) {
        check.checked = true
      }
    })

    this.$emit('formValid', this.isValid)
  }
}
